import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "@apollo/client"
import {concat, split} from "@apollo/client/link/core"
import {onError} from "@apollo/client/link/error"

import CommonUtils from "./utils/Common"

CommonUtils.GetSettingInit()

// URL des API
const CommonUrl = CommonUtils.GetSetting("COMMON_API_URL")
const BusinessUrl = CommonUtils.GetSetting("BUSINESS_API_URL")

const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext(({headers = {}}) => ({
        headers: {
            ...headers,
            authorization: "Bearer " + CommonUtils.GetLocal("accessToken") || null,
            roleToken: CommonUtils.GetLocal("odmToken")
        }
    }))
    return forward(operation)
})

// Création des liens pour chaque API
const BusinessLink = concat(
    authMiddleware,
    new HttpLink({
        uri: BusinessUrl
    })
)

const CommonLink = concat(
    authMiddleware,
    new HttpLink({
        uri: CommonUrl
    })
)

// Gestion des erreurs (optionnel)
const errorLink = onError(({graphQLErrors, networkError}) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({message, locations, path}) =>
            console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        )
    }
    if (networkError) console.log(`[Network error]: ${networkError}`)
})

// Utilisation d'Apollo Link pour router vers la bonne API en fonction des requêtes

const link = split((operation) => operation.getContext().clientName === "CommonUrl", CommonLink, BusinessLink)

export const cache = new InMemoryCache({
    addTypename: false,
    dataIdFromObject: undefined
})

// Création du client Apollo avec le lien combiné
const apolloClient = new ApolloClient({
    link: ApolloLink.from([errorLink, link]),
    cache
})

export default apolloClient
